import { call, put, takeEvery } from "redux-saga/effects";
import {
  getAppointmentSuccess,
  getAppointmentError,
  appointmentActionPatchSuccess,
  appointmentActionPatchError,
  getAppointmentActionSuccess,
  getAppointmentActionError,
} from "./actions";
import {
  getAppointment,
  getAppointmentAction,
  patchAppointmentAction
} from "../../resources/helper/appointment";
import { GET_APPOINTMENT, APPOINTMENTACTION_PATCH, GET_APPOINTMENTACTION } from "./actionTypes";

function* Appointment({ payload: { appointment } }) {
  try {    
    const response = yield call(
      getAppointment,
      appointment.quoteId,
    );
    yield put(getAppointmentSuccess(response));
  } catch (error) {
    yield put(getAppointmentError(error));
  }
}

function* AppointmentAction({ payload: { appointment } }) {
  try {
    const response = yield call(getAppointmentAction, appointment.appointmentId);
    yield put(getAppointmentActionSuccess(response));
  } catch (error) {
    yield put(getAppointmentActionError(error));
  }
}

function* AppointmentActionPatch({ payload: { appointmentActionBody, appointmentId } }) {
  try {
    const response = yield call(patchAppointmentAction, appointmentActionBody, appointmentId);
    yield put(appointmentActionPatchSuccess(response));
  } catch (error) {
    yield put(appointmentActionPatchError(error));
  }
}

function* AppointmentSaga() {
  yield takeEvery(GET_APPOINTMENT, Appointment);
  yield takeEvery(GET_APPOINTMENTACTION, AppointmentAction);
  yield takeEvery(APPOINTMENTACTION_PATCH, AppointmentActionPatch);
}

export default AppointmentSaga;
